module.exports = __webpack_public_path__ + "static/defaultRestaurantPinHover-f90db53f0071926d57a7b708ea755c3c.png";